<template>
  <v-layout full-height :class="routeComposable.meta.fullLayoutBackgroundColor ?? 'bg-purple-4'">
    <v-app-bar
      elevation="0"
      :color="
        routeComposable.meta.fullLayoutBackgroundColor
          ? (routeComposable.meta.fullLayoutBackgroundColor as string).replace('bg-', '')
          : 'transparent'
      "
      class="py-3"
    >
      <template #prepend>
        <v-btn
          v-if="merchantsStore.verifiedAndActiveMerchants.length > 0"
          icon
          offset-y
          style="opacity: 0"
        />
        <v-btn v-if="authStore.user.isAuthenticated" icon offset-y style="opacity: 0" />
      </template>

      <v-spacer v-if="!routeComposable.meta.fullLayoutLogoLeftAligned" />
      <RouterLink to="/">
        <v-img
          :src="logo"
          alt="yetipay"
          :width="routeComposable.meta.fullLayoutLogoLeftAligned ? '88px' : '176px'"
          height="50px"
          :class="routeComposable.meta.fullLayoutLogoLeftAligned ? 'ms-4 ms-md-8' : 'mx-auto'"
        />
      </RouterLink>
      <v-spacer />

      <template #append>
        <v-btn
          v-if="merchantsStore.verifiedAndActiveMerchants.length > 0"
          icon
          offset-y
          @click="merchantsStore.initialize().then(() => router.push('/'))"
        >
          <v-icon class="on-secondary"> mdi-close-circle-outline </v-icon>
        </v-btn>

        <v-menu v-if="authStore.user.isAuthenticated" offset-y>
          <template #activator="{ props }">
            <v-btn icon v-bind="props">
              <v-icon class="on-secondary"> mdi-account-circle </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                ><v-icon>mdi-at</v-icon> {{ authStore.user.email }}</v-list-item-title
              >
            </v-list-item>
            <LocaleSelector />
            <v-list-item link @click.prevent="logout">
              <v-list-item-title
                ><v-icon>mdi-logout</v-icon> {{ t("layouts.full.logout") }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-app-bar>

    <v-main class="mt-6" style="padding-bottom: 0 !important">
      <router-view v-slot="{ Component, route }">
        <transition name="fade" mode="out-in">
          <div :key="route.path" :class="route.name === 'join' ? 'fill-height' : 'mb-10'">
            <component :is="Component" class="my-10" />
          </div>
        </transition>
      </router-view>
    </v-main>

    <Footer
      v-if="routeComposable.name !== 'join' || !onboardingStore.draftMerchant"
      :class="routeComposable.meta.fullLayoutBackgroundColor ?? 'background'"
    />
  </v-layout>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import logoBlack from "@/assets/img/yetipay-logo-black.svg";
import logoWhite from "@/assets/img/yetipay-logo-white.svg";
import { useAuthenticationStore } from "@/store/authentication";
import { useMerchantsStore } from "@/store/merchants";
import { useOnboardingStore } from "@/store/onboarding";

const authStore = useAuthenticationStore();
const merchantsStore = useMerchantsStore();
const router = useRouter();
const routeComposable = useRoute();
const onboardingStore = useOnboardingStore();
const { t } = useI18n();

const logo = computed(() =>
  !routeComposable.meta.fullLayoutBackgroundColor ? logoWhite : logoBlack,
);

const logout = async () => {
  await authStore.signOut();
  router.push("/signin");
};
</script>
